import Security from "components/Settings/SecurityTab/index";
import React from "react";

function OrganizationSecurity() {
  return (
    <>
      {" "}
      <Security />
    </>
  );
}

export default OrganizationSecurity;
